( function() {
	'use strict';

	function pinDotToLastWord() {
		const titles = document.querySelectorAll( '.hero-internal__title' );

		titles.forEach( function( el ) {
			el.innerHTML = el.innerHTML.replace(
				/(\S+)(\s*)$/,
				'<span class="hero-internal__title-last-word">$1</span>$2'
			);
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', pinDotToLastWord );
	} else {
		pinDotToLastWord();
	}
}() );
